import { HubspotDialogCommandHandler } from '@/services/hubspot/commands/hubspot-dialog.commands';
import { HubspotDialogService, HubspotDialogServiceImpl } from '@/services/hubspot/hubspot-dialog.service';
import { CommandContribution } from '@patsnap/tahiti-core';
import { type interfaces } from '@patsnap/tahiti-core/shared/inversify';

/**
 * HubSpot 相关服务的依赖注入模块
 */
export const hubspotModule = (bind: interfaces.Bind) => {
    // 绑定 HubSpot 对话框服务
    bind(HubspotDialogService).to(HubspotDialogServiceImpl);

    // 绑定命令处理器
    bind(CommandContribution).to(HubspotDialogCommandHandler);
};
